module.exports = __webpack_public_path__ + "img/logo_19.214aded5.png";